import React from 'react';

function Image02Icon({ fill, ...restProps }) {
  return (
    <>
      <svg
        fill={fill ?? ''}
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
        {...restProps}
      >
        <path
          d='m11.28 1.023-.56.06A10.685 10.685 0 0 0 7.18 2.12c-1.135.551-1.987 1.165-2.942 2.119-.961.959-1.595 1.841-2.141 2.981C.301 10.968.728 15.286 3.226 18.633c.475.636 1.527 1.683 2.174 2.164 3.964 2.948 9.266 2.937 13.237-.027.609-.454 1.679-1.524 2.133-2.133 2.974-3.985 2.974-9.289 0-13.274-.454-.608-1.523-1.677-2.13-2.128-1.595-1.186-3.275-1.875-5.217-2.139C13 1.038 11.574.99 11.28 1.023m2.04 2.078c2.563.387 4.804 1.83 6.24 4.019.303.463.743 1.359.932 1.9.404 1.16.579 2.535.471 3.72a9.14 9.14 0 0 1-.07.613c-.021.082-.234-.117-1.828-1.702-1.043-1.038-1.894-1.851-2.015-1.928a2.038 2.038 0 0 0-2.1 0c-.132.082-1.842 1.759-4.617 4.53l-4.407 4.4-.33-.337a9.08 9.08 0 0 1-2.329-4.156c-.186-.763-.244-1.272-.244-2.16 0-1.493.257-2.621.897-3.94a8.983 8.983 0 0 1 5.24-4.594c.705-.233 1.272-.348 2.18-.442.322-.033 1.571.015 1.98.077m-5.512 2.48c-.933.203-1.839 1.02-2.14 1.929-.448 1.356.056 2.772 1.265 3.55.889.572 2.245.572 3.134 0 1.208-.778 1.713-2.194 1.265-3.549-.304-.92-1.21-1.731-2.158-1.932-.34-.072-1.031-.071-1.366.002m1.215 2.081c.283.174.431.432.451.784.013.237 0 .305-.095.499-.349.713-1.379.724-1.748.018a.98.98 0 0 1 .418-1.341c.181-.092.251-.105.495-.094.232.011.319.035.479.134m9.105 5.886 2.108 2.107-.224.436a9.044 9.044 0 0 1-1.696 2.309 8.464 8.464 0 0 1-2.336 1.661 8.96 8.96 0 0 1-7.869.052c-.281-.136-.511-.257-.511-.27 0-.028 8.372-8.403 8.4-8.403.011 0 .968.948 2.128 2.108'
          fill-rule='evenodd'
          fill={fill ?? ''}
        />
      </svg>
    </>
  );
}

export default Image02Icon;
